import egsPsLogo from "@/assets/logo-egs-ps.png";
import { useCurrentEnrollment } from "@/hooks/current-enrollment.hook";
import { useResourceLibrary } from "@/hooks/resource-library.hook";
import { parseISO } from "date-fns";
import { format } from "date-fns/format";
import { useParams } from "react-router-dom";
import EnrollmentComplete from "./enrollment-complete";
import EnrollmentForm from "./enrollment-form";
import EnrollmentSkeleton from "./enrollment-skeleton";

const EnrollmentPage = () => {
  const { editionId } = useParams();

  const {
    currentApplication,
    currentApplicationIsLoading,
    edition,
    isEditionLoading,
    enrollmentlMilestone,
  } = useCurrentEnrollment(editionId || "");

  // Check if the enrollment has been completed
  const enrollmentComplete = currentApplication?.status !== "NOT_ENROLLED";

  const { error: resourceLibraryError, isLoading: isResourceLibraryLoading } =
    useResourceLibrary();

  const startDate = enrollmentlMilestone
    ? format(parseISO(enrollmentlMilestone.startDate), "dd MMMM yyyy")
    : null;

  const endDate = enrollmentlMilestone
    ? format(parseISO(enrollmentlMilestone.endDate), "dd MMMM yyyy")
    : null;

  if (!editionId) {
    throw new Error("No se especifícó la edición.");
  }

  if (resourceLibraryError) {
    throw resourceLibraryError;
  }

  return (
    <div className="mx-auto max-w-lg p-8">
      <img
        className="mx-auto mb-12"
        src={egsPsLogo}
        width={220}
        alt="Logotipo Empresa con Gestión Sostenible"
      />

      {isEditionLoading ||
      currentApplicationIsLoading ||
      isResourceLibraryLoading ? (
        <EnrollmentSkeleton />
      ) : edition ? (
        <>
          <header>
            <h1 className="my-2 text-center text-xl font-semibold text-[#13171B]">
              Registro {edition.name}
            </h1>
          </header>

          {enrollmentComplete ? (
            <EnrollmentComplete />
          ) : (
            <>
              <div className="text-center">
                <p>Llena tus datos para inscribirte en esta nueva edición.</p>
                {enrollmentlMilestone && (
                  <p className="text-sm">
                    <strong>
                      Plazos: {startDate} - {endDate}
                    </strong>
                  </p>
                )}
              </div>
              <EnrollmentForm />
            </>
          )}
        </>
      ) : (
        <div className="text-center">
          No se pudo cargar los datos de la edición actual.
        </div>
      )}
    </div>
  );
};

export default EnrollmentPage;
